import { createContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../auth/firebase-config";

export const AuthContext = createContext();
//Authentication 
const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState();

  //*This func.  will be taken last user
  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      setCurrentUser(currentUser);
    });
  }, []);
  return (
    <AuthContext.Provider value={{ currentUser }}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContextProvider;
